var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClarityArrowLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clarity:arrow-line",
    clipPath: "url(#clip0_573_2058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.6604 15.6791L18.0004 6.06909L8.34045 15.6791C8.22648 15.7659 8.13248 15.8761 8.06483 16.0024C7.99717 16.1287 7.95744 16.268 7.94832 16.411C7.9392 16.554 7.9609 16.6972 8.01196 16.8311C8.06301 16.9649 8.14223 17.0862 8.24425 17.1868C8.34627 17.2874 8.46871 17.3649 8.60327 17.414C8.73784 17.4631 8.88139 17.4828 9.02421 17.4716C9.16703 17.4605 9.30579 17.4188 9.43109 17.3493C9.55638 17.2799 9.66529 17.1843 9.75045 17.0691L17.0004 9.87909V29.0091C17.0004 29.2743 17.1058 29.5287 17.2933 29.7162C17.4809 29.9037 17.7352 30.0091 18.0004 30.0091C18.2657 30.0091 18.52 29.9037 18.7076 29.7162C18.8951 29.5287 19.0004 29.2743 19.0004 29.0091V9.87909L26.2504 17.0691C26.4388 17.2561 26.6936 17.3606 26.959 17.3596C27.2243 17.3587 27.4785 17.2524 27.6654 17.0641C27.8524 16.8758 27.9569 16.6209 27.956 16.3556C27.9551 16.0902 27.8488 15.8361 27.6604 15.6491V15.6791Z",
    fill: "#FBFEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_2058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0 0.0690918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityArrowLine);
export default __webpack_public_path__ + "static/media/clarity_arrow-line.1f3be7de61a8034571eea8e01a22fd33.svg";
export { ForwardRef as ReactComponent };